import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import { withDevice } from '@surfline/quiver-react';
import { getSpotMultiCam, getSpotReportData } from '../../selectors/spot';
import { trackEvent } from '../../actions/segmentEvents';
import { setPrimaryCam, setCamView } from '../../actions/multiCam';
import SpotReportCams from './SpotReportCams';

export default withDevice(
  connect(
    state => ({
      multiCam: getSpotMultiCam(state),
      reportData: getSpotReportData(state),
    }),
    dispatch => ({
      doTrackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
      doLoadTreatments: treatment => dispatch(loadTreatment(treatment)),
      doSetPrimaryCam: camera => dispatch(setPrimaryCam(camera)),
      doSetCamView: activeView => dispatch(setCamView(activeView)),
    })
  )(withRouter(SpotReportCams))
);
